<template>
    <BlocoAccordion
        titulo="Comercial"
        tema="comercial"
        subtitulo="3 indicadores"
        descricao="Propostas, produtos vendidos e clientes conquistados"
    >
        <PropostasComerciais @updateMes="atualizarMes" :mes="mes" :ano="ano" />
        <ProdutosVendidos @updateMes="atualizarMes" :mes="mes" :ano="ano" />
        <ClientesConquistados @updateMes="atualizarMes" :mes="mes" :ano="ano" />
    </BlocoAccordion>
</template>

<script>
import BlocoAccordion from './BlocoAccordion.vue';
import ClientesConquistados from './Graficos/Comercial/ClientesConquistados.vue';
import ProdutosVendidos from './Graficos/Comercial/ProdutosVendidos.vue';
import PropostasComerciais from './Graficos/Comercial/PropostasComerciais.vue';

export default {
    name: 'BlocoComercial',
    components: {
        BlocoAccordion,
        PropostasComerciais,
        ProdutosVendidos,
        ClientesConquistados,
    },
    props: {
        mes: { required: true },
        ano: { required: true },
    },
    emits: ['updateMes'],
    methods: {
        atualizarMes(mes) {
            this.$emit('updateMes', mes);
        },
    },
};
</script>
